import { render, staticRenderFns } from "./DateQuestion.vue?vue&type=template&id=79b9e270&"
import script from "./DateQuestion.vue?vue&type=script&lang=ts&"
export * from "./DateQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79b9e270')) {
      api.createRecord('79b9e270', component.options)
    } else {
      api.reload('79b9e270', component.options)
    }
    module.hot.accept("./DateQuestion.vue?vue&type=template&id=79b9e270&", function () {
      api.rerender('79b9e270', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/accounts/accountApplication/accountApplicationForm/typesOfQuestion/DateQuestion.vue"
export default component.exports